import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import styles from './Styles';
import AuthService from '../../Services/AuthService';


function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};
class Account extends Component {
  constructor(props) {
    super(props)
    this.Auth = new AuthService();
    this.state = {
      auth: false,
      lead: '',
      username: '',
      oldPassword: '',
      newPassword: '',
      profile: {}
    }
    this.handleChange = this.handleChange.bind(this);
    this.handlePassword = this.handlePassword.bind(this)
  }

  componentWillMount() {
    this.state.lead = localStorage.getItem('hasLead');
    if (this.Auth.loggedIn()) {
      this.state.auth = true;
      this.state.username = localStorage.getItem('username')
    } else {
      this.props.history.replace(`/signin`);
      window.location.reload();
    }
  }

  handleChange = async event =>{
    this.setState({ [event.target.name]:event.target.value })
  }

  handlePassword = async event =>{
    event.preventDefault();
    const url = "https://connect-back-end.scottguo.com/auth/resetPassword"
    const password = {
      newPassword: this.state.newPassword,
      oldPassword: this.state.oldPassword
    }
    console.log(password)
    const headers = {
      'Content-type': 'application/json'
    }
    if (this.Auth.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.Auth.getToken()
    }
    fetch(url, {
      headers,
      method: 'POST',
      body: JSON.stringify(password),
    })
    .then(res => {
      window.location.reload();
      this.props.history.push('/');
      return res.json()
    })
    .catch(error => console.error('Error:', error))
  }

  render(){
    const { classes, theme } = this.props;
    const { profile } = this.state;
    return (
      <div style={{
        padding: '15px 50px 75px',
        width: '1200px',
        margin: 'auto',

      }}>
      
        <main className={classes.layout}>
        <TabContainer dir={theme.direction}>
        <form className={classes.form} onSubmit={this.handlePassword}>
        <div style={{
        padding: '15px 50px 75px',
        width: '120x',
        margin: 'auto',
      }}>
      <h2>Reset Your Password</h2>
        <FormControl margin="normal" required fullWidth>
        
        <InputLabel htmlFor="name">Enter Your old Password</InputLabel>
        <Input 
              id="oldPassword" 
              name="oldPassword"
              type="password" 
              autoFocus 
              value={this.state.oldPassword} 
              onChange={evt => this.setState({
                oldPassword: evt.target.value
              })}
        />
        </FormControl>
        <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="name">Enter Your New Password</InputLabel>
        <Input 
              id="newPassword" 
              name="newPassword"
              type="password" 
              autoFocus 
              value={this.state.newPassword} 
              onChange={evt => this.setState({
                newPassword: evt.target.value
              })}
        />
        </FormControl>
        <Button
              type="submit"
              variant="raised"
              color="primary"
              className={classes.submit}
            >
              Change the password
          </Button>
        </div>
        </form>
        </TabContainer>
        </main>
      </div>
  );
  }
}

Account.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme:true})(Account)


// WEBPACK FOOTER //
// ./src/components/Users/Account.js